import { mapValues, pick } from 'lodash';
import blockStylingSelectors from '../config/editorBlock/blockStylingSelectors';
import stylingKeysToBlockProps from '../config/editorBlock/stylingKeysToBlockProps';

export const mergeBlockStylingSelectors = (state, { type, ownBlockStyles }) => {
  const selectors = blockStylingSelectors[type];

  const evaluateStylingSelector = (selector, stylingKey) => {
    const blockPropName = stylingKeysToBlockProps[type][stylingKey];
    const ownStyle = ownBlockStyles[blockPropName];

    return selector(state, ownStyle);
  };

  return {
    mergedStyling: mapValues(selectors, evaluateStylingSelector),
    localStyling: mapValues(selectors, selector => selector(state)),
  };
};

export const getMergedStyling = (state, block) =>
  mergeBlockStylingSelectors(state, {
    type: block.type,
    ownBlockStyles: pick(
      // normalizing data to accept only styling block type related  @sinslav
      block,
      Object.values(stylingKeysToBlockProps[block.type]),
    ),
  });
